import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createStatementOfAccountsApi(params: any) {
  let apiData: any = {
    startDate: params.startDate,
    endDate: params.endDate,
    customerExternalId: params.customerExternalId.length ? params.customerExternalId : null,
    loanAccountNumber: params.loanAccountNumber.length ? params.loanAccountNumber : null,
    saveReport: params.saveReport
  };
  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/statement-of-accounts`;
  return api.create(`${backendApiUrl}`, apiData);
}
export { createStatementOfAccountsApi };
